import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as LabelPrimitive from '@radix-ui/react-label';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import { LabelSlot } from './components/slot/Slot.mjs';
import { labelRoot, labelContent, label } from './label.vanilla.mjs';
import { getDisabledDataAttribute } from './utils/data-attribute.mjs';

const Label = forwardRef(
  ({
    children,
    className: classNameFromProps,
    disabled,
    leftSlot,
    rightSlot,
    required,
    state,
    ...props
  }, forwardedRef) => {
    const [labelElement, setLabelElement] = useState(null);
    const isWithInField = labelElement?.closest(
      '[data-scope="form-field"], [data-scope="text-field"], [data-scope="text-area"]'
    ) !== null;
    const className = classNames(
      labelRoot({ state, withInField: isWithInField }),
      classNameFromProps
    );
    return /* @__PURE__ */ jsxs(
      StyledSpan,
      {
        "data-scope": "label",
        "data-part": "root",
        ...getDisabledDataAttribute(disabled),
        className,
        ref: forwardedRef,
        ...props,
        children: [
          /* @__PURE__ */ jsxs("div", { "data-scope": "label", "data-part": "content", className: labelContent, children: [
            /* @__PURE__ */ jsx(LabelSlot, { "data-scope": "label", "data-part": "left-slot", children: leftSlot }),
            /* @__PURE__ */ jsx(
              LabelPrimitive.Root,
              {
                "data-scope": "label",
                "data-part": "label",
                className: label({ required }),
                ref: setLabelElement,
                children
              }
            )
          ] }),
          /* @__PURE__ */ jsx(LabelSlot, { "data-scope": "label", "data-part": "right-slot", children: rightSlot })
        ]
      }
    );
  }
);
const StyledSpan = styled("span");
Label.toString = () => '[data-scope="label"][data-part="root"]';
Label.displayName = "Label";

export { Label };
//# sourceMappingURL=Label.mjs.map
